import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_CONTENTFUL_DATA_ARTICLE,
    CONTENTFUL_LOAD_CLIENT_PARTIAL,
    CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS,
    CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED,
    FETCH_CONTENTFUL_DATA_ARTICLE_SUCCESS,
    FETCH_CONTENTFUL_DATA_ARTICLE_FAILED,
    FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL,
    FETCHING_CONTENTFUL_DATA_ARTICLE,
    FETCH_COACH_INFO,
    FETCH_COACH_INFO_SUCCESS,
    FETCH_COACH_INFO_FAILED,
    FETCHING_COACH_INFO,
    FETCH_PREPLAN_COACH_INFO,
    FETCH_PREPLAN_COACH_INFO_SUCCESS,
    FETCH_PREPLAN_COACH_INFO_ERROR,
    FETCH_COACH_VIDEO,
    FETCH_COACH_VIDEO_SUCCESS,
    FETCH_COACH_VIDEO_ERROR
} from '../actions/ActionTypes';

// worker
export function* fetchContentFulContentForArticle(action) {
    try {
        const { contentID, locale } = action.payload;

        yield put({
            type: FETCHING_CONTENTFUL_DATA_ARTICLE
        });

        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                operationName: 'articles',
                query: `query articles{Articles(articleTitle:"${contentID}", locale:"${locale}"){articleItems{fields{dateField,title,deck,imageUrl,paragraph,articleDuration}}}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: FETCH_CONTENTFUL_DATA_ARTICLE_FAILED,
                error: response.data.errors[0].message,
                action: action.payload
            });
        } else {
            yield put({
                type: FETCH_CONTENTFUL_DATA_ARTICLE_SUCCESS,
                adaptiveTrainingPlanArticle: response.data.data.Articles,
                action: action.payload
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_CONTENTFUL_DATA_ARTICLE_FAILED,
            error: e,
            action: action.payload
        });
    }
}

export function* fetchPartialContentFulArticle(action) {
    try {
        const { contentID, locale } = action.payload;

        yield put({
            type: FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL
        });

        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                operationName: 'articles',
                query: `query articles{Articles(articleTitle:"${contentID}", locale:"${locale}"){articleItems{fields{dateField,title,deck,imageUrl,articleDuration}}}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED,
                error: response.data.errors[0].message,
                action: action.payload
            });
        } else {
            yield put({
                type: CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS,
                atpFeedPartialContent: response.data.data.Articles,
                action: action.payload
            });
        }
    } catch (e) {
        yield put({
            type: CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED,
            error: e,
            action: action.payload
        });
    }
}

// worker
export function* fetchCoachInfo(action) {
    try {
        const { contentID, locale } = action.payload;

        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                query: `{Coaches(coachKey: "${contentID}", locale: "${locale}") { fields{ firstName, lastName, tagLine, xxxhdpiUrl, coachKey}}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: FETCH_COACH_INFO_FAILED,
                error: response.data.errors[0].message
            });
        } else {
            yield put({
                type: FETCH_COACH_INFO_SUCCESS,
                atpCoachInfo: response.data.data.Coaches.fields
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_COACH_INFO_FAILED,
            error: e,
            action: action.payload
        });
    }
}

export function* fetchPreplanCoachInfo({ contentfulContentId, fields, lang }) {
    try {
        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                query: `{Coaches(coachKey: "${contentfulContentId}", locale: "${lang}") { fields{ ${fields.join(
                    ','
                )} }}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: FETCH_PREPLAN_COACH_INFO_ERROR,
                error: response.data.errors[0].message
            });
        } else {
            yield put({
                type: FETCH_PREPLAN_COACH_INFO_SUCCESS,
                data: {
                    contentfulContentId: contentfulContentId,
                    atpCoachInfo: response.data.data.Coaches.fields
                }
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_PREPLAN_COACH_INFO_ERROR,
            error: e,
            action: contentfulContentId
        });
    }
}

export function* fetchCoachVideo({ coachKey, videoKey, lang }) {
    try {
        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                query: `{Videos(videoKey: "${videoKey}", locale: "${lang}") {fields {videoUrl, videoTitle, videoThumbnailUrl, subtitleUrl }} Coaches(coachKey: "${coachKey}", locale: "${lang}") {fields{firstName, lastName, xxxhdpiUrl, tagLine}}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: FETCH_COACH_VIDEO_ERROR,
                error: response.data.errors[0].message
            });
        } else {
            yield put({
                type: FETCH_COACH_VIDEO_SUCCESS,
                data: {
                    contentfulContentId: coachKey,
                    coachInfo: response.data.data.Coaches.fields,
                    videoData: response.data.data.Videos.fields
                }
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_COACH_VIDEO_ERROR,
            error: e,
            action: coachKey
        });
    }
}

// watcher
export const atpContentFulSaga = [
    takeEvery(FETCH_CONTENTFUL_DATA_ARTICLE, fetchContentFulContentForArticle),
    takeEvery(CONTENTFUL_LOAD_CLIENT_PARTIAL, fetchPartialContentFulArticle),
    takeEvery(FETCH_COACH_INFO, fetchCoachInfo),
    takeEvery(FETCH_PREPLAN_COACH_INFO, fetchPreplanCoachInfo),
    takeEvery(FETCH_COACH_VIDEO, fetchCoachVideo)
];
